// Self-hosted fleet images (bundled in /public/fleet) so they never depend on
// an external CDN that some ISPs block. Falls back to the backend image, then a placeholder.
const OVERRIDES = {
  shuttle: "/fleet/shuttle.jpg",
  economy_sedan: "/fleet/economy_sedan.jpg",
  comfort_sedan: "/fleet/comfort_sedan.jpg",
  luxe_sedan: "/fleet/luxe_sedan.jpg",
  economy_ev: "/fleet/economy_ev.jpg",
  comfort_ev: "/fleet/comfort_ev.jpg",
  minivan: "/fleet/minivan.jpg",
  vip_van: "/fleet/vip_van.jpg",
  vip_sedan: "/fleet/vip_sedan.jpg",
};

export const FLEET_FALLBACK = "/vaya-icon-100.png";

export const vehicleImage = (classId, fallback) => OVERRIDES[classId] || fallback || FLEET_FALLBACK;
